import React from 'react';

import type { IconProps } from '~/components/icons/types';

import SvgIcon from '../core/SvgIcon';

const StackIcon: React.FC<IconProps> = ({ iconColor, ...props }) => (
  <SvgIcon viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" disableStrokeColor iconColor={iconColor} {...props}>
    <path
      d="M21.6478 16.125A0.75 0.75 0 0 1 21.375 17.1478l-9 5.25a0.75 0.75 0 0 1 -0.7556 0l-9 -5.25A0.75 0.75 0 0 1 3.375 15.8522l8.625 5.0297 8.625 -5.0297A0.75 0.75 0 0 1 21.6478 16.125ZM20.625 11.3522l-8.625 5.0297L3.375 11.3522A0.75 0.75 0 0 0 2.625 12.6478l9 5.25a0.75 0.75 0 0 0 0.7556 0l9 -5.25A0.75 0.75 0 1 0 20.625 11.3522ZM2.25 7.5a0.75 0.75 0 0 1 0.375 -0.6478l9 -5.25a0.75 0.75 0 0 1 0.7556 0l9 5.25a0.75 0.75 0 0 1 0 1.2956l-9 5.25a0.75 0.75 0 0 1 -0.7556 0l-9 -5.25A0.75 0.75 0 0 1 2.25 7.5Zm2.2388 0L12 11.8819 19.5113 7.5 12 3.1181Z"
      fill={iconColor}
    />
  </SvgIcon>
);

export default StackIcon;
